import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
                    <h3 className="footer-title">GetStrandX</h3>
            <p className="footer-description">
              Roadside assistance and DIY car care, powered by your community.
              Get help when you're stuck — or learn the skills to handle it yourself.
            </p>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-heading">App</h4>
              <ul className="footer-list">
                <li><Link to="/#features" className="footer-link">Features</Link></li>
                <li><Link to="/#learn-diy" className="footer-link">Learn DIY</Link></li>
                <li><Link to="/#prelaunch-survey" className="footer-link">Get Early Access</Link></li>
                <li><Link to="/#how-it-works" className="footer-link">How It Works</Link></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h4 className="footer-heading">Support</h4>
              <ul className="footer-list">
                <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
                <li><Link to="/#prelaunch-survey" className="footer-link">Join Community</Link></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h4 className="footer-heading">About</h4>
              <ul className="footer-list">
                <li><Link to="/about" className="footer-link">About Us</Link></li>
                <li><Link to="/privacy" className="footer-link">Privacy Policy</Link></li>
                <li><Link to="/terms" className="footer-link">Terms of Service</Link></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
                      © 2025 GetStrandX. All rights reserved.
            </p>
            <div className="footer-legal">
              <Link to="/privacy" className="footer-legal-link">Privacy Policy</Link>
              <Link to="/terms" className="footer-legal-link">Terms of Service</Link>
              <Link to="/about" className="footer-legal-link">About Us</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
